'use strict';


import { ThreeJSOverlayView } from '@googlemaps/three';
import { PCFSoftShadowMap, REVISION, WebGLRenderer } from 'three';

export class ThreeJsOverlay extends ThreeJSOverlayView{
	constructor (options) {
		super(options);
		this.needsUpdate = false;
	}
	
	onContextRestored ({gl}) {
		this.renderer = new WebGLRenderer({
			canvas: gl.canvas,
			antialias: true,
			context: gl,
			...gl.getContextAttributes(),
		});
		this.renderer.autoClear = false;
		this.renderer.autoClearDepth = false;
		this.renderer.shadowMap.enabled = true;
		this.renderer.shadowMap.type = PCFSoftShadowMap;
		// Since r152, default outputColorSpace is SRGB
		// Deprecated outputEncoding kept for backwards compatibility
		if (Number(REVISION) < 152) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			this.renderer.outputEncoding = 3001;
		}
		
		const { width, height } = gl.canvas;
		const pixelRatio = Math.min(window.devicePixelRatio, 2);
		this.renderer.setSize(width, height, false);
		this.renderer.setPixelRatio(pixelRatio);
	}
	
	resize(gl) {
		if (this.needsUpdate) {
			this.needsUpdate = false;
			const { width, height } = gl.canvas;
			
			this.renderer.setSize(width,height,false);
		}
	}
	
	onDraw ({gl, transformer}) {
		this.camera.projectionMatrix.fromArray(
			transformer.fromLatLngAltitude(this.anchor, this.rotationArray)
		);
		
		gl.disable(gl.SCISSOR_TEST);
		
		this.onBeforeDraw();
		this.resize(gl);
		this.renderer.render(this.scene, this.camera);
		this.renderer.resetState();
		
		if (this.animationMode === "always") this.requestRedraw();
	}
}
